import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { SavedGridBits } from './setRecentDashboardFilter';

export interface RecentDashboardFilter {
  id: string;
  name: string;
  isOrganization: boolean;
  configuration: SavedGridBits;
}

const getRecentDashboardFilter: QueryFunction<
  RecentDashboardFilter,
  ['/recent-dashboard-filter', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockStackFilters(queryKey[1]));
  if (!queryKey[1] || queryKey[1].trim() === '') {
    throw new Error('Field filter ID is required');
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    filter: {
      configuration: SavedGridBits;
      name: string;
      id: string;
      visibility: 'private' | 'public';
    };
  }>(`/search-filters/${queryKey[1]}`, {
    method: 'GET',
  });
  if (response.data)
    return {
      id: response.data.filter.id,
      name: response.data.filter.name,
      isOrganization: response.data.filter.visibility === 'public',
      configuration: response.data.filter.configuration,
    };
  throw new Error('Failed to fetch field filter');
};

export default getRecentDashboardFilter;

const _mockStackFilters = (id: string): RecentDashboardFilter => ({
  id,
  name: `Mock Filter ${id}`,
  isOrganization: true,
  configuration: {
    columnState: [],
    filterModel: null,
  },
});
